import { useCurrentUser } from '@shared/hooks';
import { useTranslation } from 'react-i18next';

import { TopbarMessageConfiguration } from './use-topbar-configuration';

export const useImpersonationMessage = (): TopbarMessageConfiguration | null => {
  const { user, userLogout } = useCurrentUser();
  const { t } = useTranslation();

  if (!user?.impersonator) return null;

  const impersonatorName = `${user.impersonator.username}`;
  const userName = `${user.firstName} ${user.lastName}, ${user.email}`;

  return {
    title: t('TOPBAR.IMPERSONATED_TITLE', { impersonator: impersonatorName, user: userName }),
    ctaLabel: t('TOPBAR.IMPERSONATED_CTA'),
    ctaVariant: 'secondary',
    variant: 'critical',
    ctaAction: userLogout,
  };
};
